import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { Case } from 'src/app/modules/cases/_types/case';
import { PublicCaseService } from '../../_services/public-case.service';
import { CasesService } from 'src/app/modules/cases/_services/cases.service';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { CasesFilesService } from 'src/app/modules/cases/_services/cases-files.service';
import { CaseFile } from 'src/app/modules/cases/_types/case-file';
import { environment } from 'src/environment/environment';
import { File } from '../../../common/_types/file'
import { CasesServicesService } from 'src/app/modules/cases/_services/cases-services.service';
import { CaseService } from 'src/app/modules/cases/_types/case-service';
import { CasesNotesService } from 'src/app/modules/cases/_services/cases-notes.service';
import { CaseNote } from 'src/app/modules/cases/_types/case-note';
import { CasesDetailNoteComponent } from 'src/app/modules/cases/cases-detail/note/note.component';
import { DialogService } from 'primeng/dynamicdialog';
import { ThisReceiver } from '@angular/compiler';
import { FilesService } from 'src/app/modules/common/_services/files.service';
import { date } from '@rxweb/reactive-form-validators';
import moment from 'moment';
import { NotesClientComponent } from 'src/app/modules/cases/cases-detail/notes-client/notes-client.component';
import { Contract } from 'src/app/modules/companies/_types/contract';
import { ContractsService } from 'src/app/modules/companies/_services/contracts.service';
import { PublicContractService } from '../../_services/public-contract.service';
import { Transaction } from 'src/app/modules/transactions/_types/transaction';
import { TransactionsService } from 'src/app/modules/transactions/_services/transactions.service';
import { Template } from 'src/app/modules/templates/_types/template';
import { TemplatesService } from 'src/app/modules/templates/_services/templates.service';


@Component({
    selector: 'app-public-case-info',
    templateUrl: './info.component.html',
    styleUrls: ['./info.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PublicCaseInfoComponent  {

    public isMapVisible:boolean = false;
    public case: Case = new Case();
    public caseFiles: any[] = [];
    public imagesUrl: string = environment.api_gw + 'common/files/';
    public caseFilesWithoutService: any[] = [];
    public caseService!: CaseService | null;
    public caseServices: CaseService[]=[];
    public caseServicesPrev: CaseService[]=[];
    public caseServicesFuture: CaseService[]=[];
    public contract:Contract | null = null;

    public ClientQuestion: CaseNote[] = [];
    public ClientReclamation: CaseNote[] = [];
    public invoices: Transaction[] = [];
    public loadingNotes: boolean = false;
    public totalClientReclamationRecords: number = 0;
    public totalClientQuestionRecords: number = 0;
    options: any;
    public token: string = "";
    public hasPosition: boolean = false;
    public photosCollapsed: boolean = true;

  //@ViewChild(GoogleMap, { static: false }) map: GoogleMap;
  //@ViewChild(MapInfoWindow, { static: false }) infoWindow: MapInfoWindow;
  
  public minutesCheckedPositionWorker = moment().subtract(60, 'minutes');
   public markerPositions: google.maps.LatLngLiteral[] = [];
    center: google.maps.LatLngLiteral = { lat: 40.4166400, lng: -3.7032700 };
    zoom = 14;

    constructor(
      private route: ActivatedRoute,
      private publicCaseService: PublicCaseService,
      private casesService: CasesService,
      private casesFilesService: CasesFilesService,
      private casesServicesService: CasesServicesService,
      private transactionsService: TransactionsService,
      private casesNotesService: CasesNotesService,
      private dialogService: DialogService,
      private filesService: FilesService,
      private publicContractService: PublicContractService,
      private templateService: TemplatesService
    ) { 
      navigator.geolocation.getCurrentPosition((position) => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
      });
     }

    async ngOnInit() {
      this.token = this.route.snapshot.params['token'];
      if (this.token != null && this.token != '') {
        await this.loadCaseData(this.token);
      }
    }
    
    async loadCaseData(token: string) {
      var now = new Date();


      var caseInfo = await firstValueFrom(this.publicCaseService.getCaseInfo(token));

      this.contract = await firstValueFrom(this.publicContractService.get(caseInfo.caseInfo.contractId!));

      this.case = caseInfo.caseInfo; // await firstValueFrom(this.casesService.get("9b6cfbb8-b6f0-4665-ab01-7481076a5b45", { include: ['company', 'client', 'user', 'address', 'caseState', 'caseType', 'contract'] }));
      this.caseFiles = caseInfo.caseFiles;
      this.caseFiles.forEach((caseFile: CaseFile) => {
           this.caseFilesWithoutService.push(caseFile);
       });
       this.caseServices = caseInfo.caseServices;
       if(this.caseServices.length > 0) {
        //buscamos si hay un case service para hoy, si es asi es el que mostramos.

        if(this.caseServices.findIndex(m => m.dateEnd == null && m.date.toLocaleDateString() == now.toLocaleDateString())!=-1){
          this.caseService = this.caseServices.filter(m => m.dateEnd == null && m.date.toLocaleDateString() == now.toLocaleDateString())[0];
        }
        
       }

       //ovbtenemos información de latitud/longitud del trabajador
       if(this.caseService != null && this.caseService.worker!=null){
        if(this.caseService.worker.lastPositionDate != null && moment(this.caseService.worker.lastPositionDate).isAfter(this.minutesCheckedPositionWorker)){
          if(this.caseService.worker.latitude != null && this.caseService.worker.longitude != null){
            this.markerPositions = [
              { lat: this.caseService.worker.latitude, lng:this.caseService.worker.longitude}
            ];
            this.center = {
              lat: this.caseService.worker.latitude, lng:this.caseService.worker.longitude
            };
          }
        }else{
          this.caseService.worker.latitude = null;
          this.caseService.worker.longitude = null;
        }
         
         this.caseServices = this.caseServices.filter(m => m.id != this.caseService?.id);
      }


      this.caseServicesFuture = this.caseServices.filter(m => moment(m.date).local()>moment(now).local() && m.isConfirmed == true);

      //Las pasadas o las que han sido hoy pero ya finalizadas.
      this.caseServicesPrev = this.caseServices.filter(m => 
                                                            (
                                                              moment(m.date).local() < moment(now).local()
                                                              ||
                                                              moment(m.date).local() == moment(now).local() && m.dateEnd != null
                                                            ) && m.isConfirmed == true
                                                        );
      this.ClientQuestion = caseInfo.caseNotes.filter(m => m.caseNoteType == "ClientQuestion");
      this.ClientReclamation = caseInfo.caseNotes.filter(m => m.caseNoteType == "ClientReclamation");
      this.totalClientQuestionRecords = this.ClientQuestion.length;
      this.totalClientReclamationRecords = this.ClientReclamation.length;

      //facturas
      this.invoices = caseInfo.invoices;
      console.log(this.invoices);
    }


    async editNote(note: CaseNote | null, question: boolean) {
        let ref = this.dialogService.open(NotesClientComponent, {
          closable: true,
          modal: true,
          header: (question ? 'Consulta': 'Reclamación'),
          width: '700px',
          
          data: {
            caseId: this.case.id,
            noteId: note ? note.id : null,
            caseNoteType:  (question ? 'ClientQuestion': 'ClientReclamation'),
            clientId: this.case.clientId,
            editable: true
          }
        });
    
        ref.onClose.subscribe((data: any) => {
          if(data!=null) {
            this.caseFiles = [];
            this.caseFilesWithoutService = [];
            this.loadCaseData(this.token);
          }
        });
    }

    fileIsAnImage(file: File) {
      return file.contentType.startsWith("image");
    }

    downloadFile(fileId: string) {
      this.filesService.download(fileId);
    }

    export(caseService:any){
      this.casesServicesService.printVisitReport(caseService.id!, true);
    }

    isMapAllowed():boolean{
      let ret = false;
      //si la hora de visita ya ha llegado, permitimos ver mapa
      if(this.caseService != null && this.caseService.date != null){
        if(moment(this.caseService.date).local() <= moment(new Date()).local()){
          ret = true;
        }
      }
      
      return ret;
    }

    pay(invoice: Transaction){
      this.transactionsService.pay(invoice.id!);
    }

    exportInvoice(invoice: Transaction){
      //this.templateService.getTemplateId(invoice.transactionType.code, undefined, undefined, invoice.id).then((result:any) => {
      //  if(result != null){
      let templateId = 'a2ca0d21-9413-409e-a627-08de319d834c';
      this.transactionsService.export(invoice.id!, templateId);
      //  }
      //});
    }
  
  }
